import { Pipe, PipeTransform } from '@angular/core';
import { IChallengeInfo } from 'app/core/services/mainapp/multiplePathways';

@Pipe({ name: 'selectCount' })

export class SelectCountPipe implements PipeTransform {
    transform(list: IChallengeInfo[], selected: number[]) {
        if (!list || !list.length || !selected || !selected.length) return 0;

        return list.filter(l => !!selected.filter(s => s === l.ChallengeID).length).length || 0;
    }
}